/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_pause': {
    width: 436,
    height: 436,
    viewBox: '-45 0 327 327',
    data: '<path pid="0" d="M158 0h71a8 8 0 018 8v311a8 8 0 01-8 8h-71a8 8 0 01-8-8V8a8 8 0 018-8zm0 0M8 0h71a8 8 0 018 8v311a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8zm0 0"/>'
  }
})
